const OPEN_PLAY_COMMUNITY_DATA = [
  {
    city: "Mumbai",
    image:
      "https://km-landing.s3.ap-south-1.amazonaws.com/Images/mumbai-wtsp-comm.png",
    groups: [
      {
        name: "Andheri to Bandra 2.0",
        sport: "Pickleball",
        whatsappLink: "https://chat.whatsapp.com/HBuIApDkakiL2pqmmqfeAo",
      },
      {
        name: "Thane & Navi Mumbai Pickleball Group 🏓",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/HvV5Ypv5vQ60pUrQ9rpEII?s=cl&p=a&mlu=4",
      },
      {
        name: "Navi Mumbai",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/EMkPAG8jajiFuPfQdbbU26?s=cl&p=a&mlu=4",
      },
      {
        name: "NAVI MUMBAI BADMINTON",
        sport: "Badminton",
        whatsappLink: "https://chat.whatsapp.com/HTVsqJNjUWh4hVkOhP7bjZ",
      },
      {
        name: "OpenPlay Mumbai Pickleball by Khelomore",
        sport: "Pickleball",
        whatsappLink: "https://chat.whatsapp.com/DWQhZxrdaNnG5cnG6YHdtJ",
      },
      {
        name: "OpenPlay Padel Mumbai",
        sport: "Padel",
        whatsappLink: "https://chat.whatsapp.com/EwQwiLWB9IIKyawgGoapAT",
      },
      {
        name: "OpenPlay Mumbai Padel By Khelomore",
        sport: "Padel",
        whatsappLink: "https://chat.whatsapp.com/KlkxuEBsSfrJ6JGZx7fDin7",
      },
      {
        name: "Events & Announcements",
        sport: "Padel",
        whatsappLink:
          "https://chat.whatsapp.com/CE2vFPOLIYc5P4kdMH3gqf?s=cl&p=i&mlu=0",
      },
      {
        name: "Andheri to Bandra",
        sport: null,
        whatsappLink:
          "https://chat.whatsapp.com/JEFFC7x6B3TAVXS0t2hWcq?s=sh&p=i&mlu=4",
      },
      {
        name: "OpenPlay Community Nights! ⭐✨",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/FwNxTkMGqp24dm8m5EScqU?s=sh&p=i&mlu=4",
      },
      {
        name: "Events and Announcements!",
        sport: null,
        whatsappLink:
          "https://chat.whatsapp.com/CFfJ4mDNoIzEZCHjsOL6vP?s=sh&p=i&mlu=4",
      },
      {
        name: "Mulund to Thane",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/D34Njzqy48sCF5Gykqwjl0?s=cl&p=i&mlu=4",
      },
      {
        name: "Chembur to Powai",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/DxzHR9i3OsaF8HSgVtlog5?s=cl&p=i&mlu=4",
      },
      {
        name: "Sion to Colaba",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/JnjDfly6A1NDwgggsOa0f3?s=cl&p=i&mlu=4",
      },
      {
        name: "Kandivali to Goregaon",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/Hb07erZoD687sEkp3ldP9t?s=cl&p=i&mlu=4",
      },
      {
        name: "OpenPlay Events & Experiences",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/CFfJ4mDNoIzEZCHjsOL6vP?s=cl&p=i&mlu=4",
      },
      {
        name: "Mira Bhayandar to Borivali",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/KtGDlh6yJTkGjf3MhdDvVy?s=cl&p=i&mlu=4",
      },
      {
        name: "Events & Announcements",
        sport: "Padel",
        whatsappLink:
          "https://chat.whatsapp.com/CE2vFPOLIYc5P4kdMH3gqf?s=cl&p=i&mlu=0",
      },
      {
        name: "OpenPlay Mumbai Box Cricket By Khelomore",
        sport: "Box Cricket",
        whatsappLink: "https://chat.whatsapp.com/Jv1M9vlJ6fKJQ5ieEMMkat",
      },
      {
        name: "General",
        sport: "Box Cricket",
        whatsappLink:
          "https://chat.whatsapp.com/H2JwmapRK8UEk1axEDIoSy?s=cl&p=a&ilr=0",
      },
    ],
  },

  {
    city: "Bengaluru",
    image:
      "https://km-landing.s3.ap-south-1.amazonaws.com/Images/bengaluru-wtsp-comm.png",
    groups: [
      {
        name: "Open Play Bangalore",
        sport: "Pickleball",
        whatsappLink: "https://chat.whatsapp.com/LQaZh92RUWEDpb7DiHDZXD",
      },
    ],
  },

  {
    city: "Hyderabad",
    image:
      "https://km-landing.s3.ap-south-1.amazonaws.com/Images/hyd-wtsp-comm.png",
    groups: [
      {
        name: "Open Play KheloMore Hyderabad 🏓🏓",
        sport: "Pickleball",
        whatsappLink: "https://chat.whatsapp.com/EvMesUOmbAv0gBYFAvkNad",
      },
      {
        name: "Phoenix equinox tournament KheloMore",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/CZNHT8kHjr9KHwLaQMy9Py?s=cl&p=a&mlu=0",
      },
      {
        name: "Phoenix Equinox DUPR NIGHTS",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/LSgefHVJxxS07OWWaQoZTQ?s=cl&p=a&mlu=0",
      },
      {
        name: "Pickleball Starter Camp HYD",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/Iu9X8rz0yKk76b27j80iXs?s=cl&p=a&mlu=0",
      },
      {
        name: "EQUINOX OPEN GAME",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/EyOiWPo83Hv35JvJTV1JgO?s=cl&p=a&mlu=0",
      },
    ],
  },

  {
    city: "Pune",
    image:
      "https://km-landing.s3.ap-south-1.amazonaws.com/Images/pune-wtsp-comm.png",
    groups: [
      {
        name: "OpenPlay Pune by KheloMore",
        sport: null,
        whatsappLink: "https://chat.whatsapp.com/LtGubtCGKEeHrKL9xzSkTv",
      },
      {
        name: "OpenPlay Badminton 🏸",
        sport: "Badminton",
        whatsappLink:
          "https://chat.whatsapp.com/IKTUSGogl2W38a6f3Y6je5?s=cl&p=i&ilr=2",
      },
      {
        name: "OpenPlay Padel 🎾",
        sport: "Padel",
        whatsappLink:
          "https://chat.whatsapp.com/DThsRMyO4K6HVUu0hvi65B?s=sh&p=i&mlu=4",
      },
      {
        name: "OpenPlay Pickleball",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/G7RaRzV81z0C12Fqic0VgO?s=sh&p=i&mlu=4",
      },
      {
        name: "OpenPlay Box Cricket 🏏",
        sport: "Box Cricket",
        whatsappLink:
          "https://chat.whatsapp.com/CVA1843qR4dG1RDwnSCTK3?s=sh&p=i&mlu=4",
      },
      {
        name: "OpenPlay Tennis 🎾",
        sport: "Tennis",
        whatsappLink:
          "https://chat.whatsapp.com/GWdeRXfuZPlJA09AmGT1P1?s=sh&p=i&mlu=4",
      },
      {
        name: "OpenPlay Table Tennis 🏓",
        sport: "Table Tennis",
        whatsappLink:
          "https://chat.whatsapp.com/GZcr3VVm8jlIR7obbbj8lJ?s=sh&p=i&mlu=4",
      },
      {
        name: "OpenPlay Basketball 🏀",
        sport: "Basketball",
        whatsappLink:
          "https://chat.whatsapp.com/L4Lv0vVoP1VEAAydBzHMyq?s=sh&p=i&mlu=4",
      },
    ],
  },

  {
    city: "Nagpur",
    image:
      "https://km-landing.s3.ap-south-1.amazonaws.com/Images/nagpur-wtsp-comm.png",
    groups: [
      {
        name: "Nagpur Khelomore Community",
        sport: null,
        whatsappLink:
          "https://chat.whatsapp.com/BU3OwfViJTzKgtk0MdveM4?s=cl&p=a&mlu=4",
      },
      {
        name: "Open Play Badminton",
        sport: "Badminton",
        whatsappLink:
          "https://chat.whatsapp.com/F3wvQ5OjJGvK7DfksIJHFL?s=sw&p=a&mlu=4",
      },
      {
        name: "Open Play - Turf",
        sport: "Cricket/Football",
        whatsappLink:
          "https://chat.whatsapp.com/DTGyronZjY96imc5aAAyTz?s=sw&p=a&mlu=4",
      },
      {
        name: "Venue Announcements",
        sport: null,
        whatsappLink:
          "https://chat.whatsapp.com/KHCo7uuppdoDvrNyiT6Md3?s=sw&p=a&mlu=4",
      },
      {
        name: "Open Play Pickleball",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/HIErl9OP0WdFS9XUCQxrfi?s=sw&p=a&mlu=4",
      },
    ],
  },

  {
    city: "Vadodara",
    image:
      "https://km-landing.s3.ap-south-1.amazonaws.com/Images/vadodara-wtsp-comm.png",
    groups: [
      {
        name: "OpenPlay Vadodara",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/F6Y6SwaVyA1EbqSs0CFd7A?mode=gi_t",
      },
      {
        name: "Court Queens 🎀👑",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/LK9Xbala58V68ax433fHdf?mode=gi_t",
      },
      {
        name: "Padel Community Tournament",
        sport: "Padel",
        whatsappLink:
          "https://chat.whatsapp.com/I2OUzIcQQ1m0GBvIOSFJ2Z?mode=gi_t",
      },
      {
        name: "Kids OpenPlay",
        sport: null,
        whatsappLink:
          "https://chat.whatsapp.com/EKAtrVbyRffEj56e1uGo4H?mode=gi_t",
      },
    ],
  },

  {
    city: "Surat",
    image:
      "https://km-landing.s3.ap-south-1.amazonaws.com/Images/surat-wtsp-comm.png",
    groups: [
      {
        name: "OpenPlay Surat By Khelomore",
        sport: null,
        whatsappLink:
          "https://chat.whatsapp.com/Kni6BF5hNOM7B8R0rIik5G",
      },
      {
        name: "OpenPlay Box Cricket By Khelomore",
        sport: "Box Cricket",
        whatsappLink:
          "https://chat.whatsapp.com/HHc1DlfIZAbIYDkISl2nYf?s=cl&p=a&mlu=4&ilr=4",
      },
      {
        name: "OpenPlay Pickleball By Khelomore",
        sport: "Pickleball",
        whatsappLink:
          "https://chat.whatsapp.com/FIvWWfintt5KZRd9DkWDWk?s=cl&p=a&mlu=4&ilr=4",
      },
    ],
  },

  {
    city: "Bharuch",
    image:
      "https://km-landing.s3.ap-south-1.amazonaws.com/Images/bharuch-wtsp-comm.png",
    groups: [
      {
        name: "OpenPlay Community",
        sport: null,
        whatsappLink: "https://chat.whatsapp.com/JQeGVpJmXWN6qxEFkddkQh",
      },
      {
        name: "OpenPlay Bharuch By Khelomore",
        sport: null,
        whatsappLink: "https://chat.whatsapp.com/CPRNuWmOB6X9MxZ1feA7G9",
      },
    ],
  },
  {
    city: "Indore",
    image:
      "https://km-landing.s3.ap-south-1.amazonaws.com/Images/indore-wtsp-comm.png",
    groups: [
      {
        name: "Pickleball Open Play",
        sport: "Pickleball",
        whatsappLink: "https://chat.whatsapp.com/F8Ojg6jFwrGHhH01BtN0M2",
      },
    ],
  },
];

export default OPEN_PLAY_COMMUNITY_DATA;
